function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "15mvjmo-row",
  styles: "flex-direction:row;label:row;"
} : {
  name: "15mvjmo-row",
  styles: "flex-direction:row;label:row;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "ll8kmq-column",
  styles: "flex-direction:column;label:column;"
} : {
  name: "ll8kmq-column",
  styles: "flex-direction:column;label:column;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "122lw0e-grow",
  styles: "flex-grow:1;label:grow;"
} : {
  name: "122lw0e-grow",
  styles: "flex-grow:1;label:grow;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiPageOuterStyles = function euiPageOuterStyles(_ref4) {
  var euiTheme = _ref4.euiTheme;
  return {
    euiPageOuter: /*#__PURE__*/css("display:flex;background-color:", euiTheme.colors.body, ";flex-shrink:0;", logicalCSS('max-width', '100%' // Ensures Firefox doesn't expand width beyond bounds
    ), ";;label:euiPageOuter;"),
    // Grow
    grow: _ref3,
    // Direction
    column: _ref2,
    row: _ref
  };
};